import { render, staticRenderFns } from "./sxzq_setting.vue?vue&type=template&id=eb668aea&scoped=true"
import script from "./sxzq_setting.vue?vue&type=script&lang=js"
export * from "./sxzq_setting.vue?vue&type=script&lang=js"
import style0 from "./sxzq_setting.vue?vue&type=style&index=0&id=eb668aea&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb668aea",
  null
  
)

export default component.exports